'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosLightbulb = function IoIosLightbulb(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31 13.5c0 2.4-1 4.6-2.3 6.5-0.9 1.2-1.8 2.2-2.5 3.5-1.8 3-1.4 5.7-1.4 6.4v0.1h-2.5v-10l2.5-5h-1.3l-2.5 5v10h-2.5v-10l-2.4-5h-1.3l2.5 5v10h-2.5v-0.1c0-0.5 0.2-3.4-1.5-6.4-0.8-1.3-1.6-2.3-2.5-3.5-1.3-1.9-2.3-4.1-2.3-6.5 0-6.1 5.2-11 11.3-11s11.2 4.9 11.2 11z m-13.7 24v-1.2h5v1.2h-5z m-1.3-2.5v-1.2h7.5v1.2h-7.5z m0-2.5v-1.2h7.5v1.2h-7.5z' })
        )
    );
};

exports.default = IoIosLightbulb;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-lightbulb.js
// module id = 2194
// module chunks = 0